import type { ReactNode } from 'react';
import Script from 'next/script';

import '../components/style.css';
import Head from 'next/head';

// TODO move this to shared and replace it other places
declare global {
    interface Window {
        TrackJS?: {
            install: (data: { token: string; application: string; version: string; enabled: boolean }) => void;
        };
    }
}

const SeoApp = ({ Component, pageProps }): ReactNode => (
    <>
        <Head>
            <meta name="nmp:tracking:aurora" content="0" />
            <meta name="nmp:tracking:brand" content="FINN" />
            <meta name="nmp:tracking:app-name" content="travel-seo-web" />
            <meta property="mbl:login" content="0" />
        </Head>
        <Component {...pageProps} />;
        <script src="/sourcepoint/v4.js" defer />
        <script type="text/javascript" src="https://static.finncdn.no/_c/cookie-whitelist/v1.0.22/clean.min.js" async />
        <script type="text/javascript" src="https://sdk-cdn.pulse.m10s.io/versioned/3.0/loader.min.js" defer />
        <script type="text/javascript" src="https://assets.finn.no/pkg/@finn-no/finn-pulse-init/v1/finn-pulse-init.min.js" defer />
        <script type="text/javascript" src="https://assets.finn.no/pkg/@finn-no/pulse-sdk/v0/client.min.js" defer />
        <script type="text/javascript" src="https://assets.finn.no/pkg/@finn-no/analytics/v26/analytics.min.js" async />
        <Script
            src="https://cdn.trackjs.com/agent/v3/latest/t.js"
            onLoad={() => {
                window.TrackJS?.install?.({
                    token: '74bb3e28a1604fd2b28c72c568722d21',
                    application: 'finn-travel-seo',
                    version: `'${process.env.NEXT_PUBLIC_GIT_COMMIT_SHA}'`,
                    enabled: location.host.indexOf('local') !== 0 && location.host.indexOf('127.0.0') !== 0,
                });
            }}
            crossOrigin=""
        />
    </>
);

export default SeoApp;
